module.exports = "pegasus_template/assets/blocks/header-1-tech.png";